import Header from 'components/_OldDesign/header'
import React, { ReactElement, useEffect, useState } from 'react'
import style from 'styles/Content.module.scss'
import { GetStaticProps } from 'next';
import 'react-multi-carousel/lib/styles.css';
import { strapi } from 'models/conent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Link from 'next/link';
import fetchStrapi from 'lib/fetchStrapi';
import { NextPageWithLayout } from './_app';
import OldLayout from '@components/_OldDesign/OldLayout';
import { omitDeep } from 'lodash-omitdeep';

export const getStaticProps: GetStaticProps = async () => {
  try {
    let categories = await fetchStrapi('/categories', 2);
    categories = omitDeep(categories, ['description', 'descriptionTH', 'formats', 'detail', 'detailTH', 'blogs']);
    return {
      props: {
        categories
      },
    };
  } catch (error) {
    return {
      props: {
        data: JSON.stringify(error),
      },
    };
  }
}

const Categories: NextPageWithLayout<{categories: any}> = ({ categories }) => {  
  const [content, setContent] = useState(null);
  const [search, setSearch] = useState<string>('')

  const handleSelectTag = (tag) => {
    setSearch(tag);
    searchByTitle(tag);
  }

  const searchByTitle = (search: string) => {
    if (!search) {
      setContent(categories);
    }
    const item = categories.filter(content => {
      return content.name.toLowerCase().includes(search.toLowerCase());
    });
    setContent(item);
  }

  useEffect(() => {
    setContent(categories);
    const queryString = window.location.search;
    const parameters = new URLSearchParams(queryString);
    const value = parameters?.get('tag');
    if (value) {
      handleSelectTag(value);
    }
  }, [])

  return <>
    <div className="px-12 lg:px-24">
      <Header content={ {
        content: 'ข่าวสารความรู้ทางด้านเทคโนโลยี และการบริหารธุรกิจด้วยไอทีในทุกด้าน',
        title: 'ข่าวสารความรู้ทางด้านเทคโนโลยี และการบริหารธุรกิจด้วยไอทีในทุกด้าน',
        image: null
      } }/>

      <div className={ `h-full w-full relative pt-40 pb-12 xl:pt-24` }>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-20">
          <div className="grid grid-cols-3 align-self-center">
            <Link href="/blogs">
              <div className="border-dark-blue border-2 text-center py-4 md:py-1 cursor-pointer rounded-l-xl">
                <span className="text-4xl md:text-xl lg:text-2xl underline">Blogs</span>
              </div>
            </Link>
            <Link href="/issues">
              <div
                className="border-dark-blue border-t-2 border-b-2 text-center py-4 md:py-1 cursor-pointer ">
                <span className="text-4xl md:text-xl lg:text-2xl underline">Issues</span>
              </div>
            </Link>
            <div className="bg-dark-blue border-dark-blue border-2 text-white text-center py-4 md:py-1 cursor-pointer rounded-r-xl">
              <span className="text-4xl md:text-xl lg:text-2xl ">Categories</span>
            </div>
          </div>
          <div className="relative">
            <input type="text"
              className={ `${ style.outlineNone } ${ style.search } xl:m-auto bg-white border-b w-full lg:mx-8 border-dark-blue px-2 text-dark-blue h-20 lg:h-12 text-2xl md:text-xl lg:text-2xl` }
              placeholder="Search Tag" value={ search } onChange={ (e) => {
              setSearch(e.target.value)
              searchByTitle(e.target.value);
            } }/>
            <FontAwesomeIcon icon={ faSearch }
              className="absolute right-3 text-2xl fa-2x top-5 lg:top-2 text-dark-blue"/>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-20 pb-12">
        <div className="align-self-center text-7xl lg:text-4xl font-bold text-dark-blue">
          Categories
        </div>
      </div>

      <div className="grid grid-rows-1 md:grid-cols-2 2xl:grid-cols-3 md:gap-x-12 gap-y-16 md:gap-y-32 2xl:gap-y-12 mb-44 lg:mb-60">
        { content?.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1).map((item, i) =>
          <Link href={ '/categories/' + item.id + '-' + item.name } key={ i }>
            <div className="relative text-center">
              <img className={ `${ style.category } w-full cursor-pointer rounded-3xl shadow-2xl` } alt="hero"
                src={ strapi + item.image?.url }/>
              <div
                className="absolute absolute-center text-white text-5xl md:text-3xl cursor-pointer underline wrap-anywhere break-words w-11/12">{ item.name?.toUpperCase() }</div>
            </div>
          </Link>
        ) }
      </div>
    </div>
    {/*<Subscribe/>*/}
  </>
}

Categories.getLayout = (page: ReactElement) => {
  return <OldLayout>{page}</OldLayout>;
};

export default Categories;
